import camelcaseKeys from 'camelcase-keys';
import { z } from 'zod';

/** Pagination metadata of paginated collection responses (the `page`/`num_per_page` envelope). */
export const PaginationSchema = z
  .object({
    page: z.number(),
    num_per_page: z.number(),
    total_count: z.number(),
    total_pages: z.number()
  })
  .transform((data) => camelcaseKeys(data));

export type Pagination = z.infer<typeof PaginationSchema>;

/** Body of a `200` answer that only confirms the request, e.g. `{"message": "Request successful."}`. */
export const MessageResponseSchema = z.object({
  message: z.string()
});

/** Body of a `204 No Content` answer, which carries nothing. */
export const NoContentResponseSchema = z.undefined();
